// ============================================================================
// MAPBOX LAYER CONFIGURATION
// ============================================================================

// Color Palettes
export const COLOR_PALETTES = {
  point: [
    '#D81B60', '#8E24AA', '#5E35B1', '#3949AB', '#1E88E5',
    '#039BE5', '#00ACC1', '#00897B', '#F4511E', '#FB8C00',
    '#FDD835', '#C0CA33', '#6D4C41', '#546E7A', '#263238',
    '#C62828', '#AD1457', '#6A1B9A', '#283593', '#1565C0',
    '#0277BD', '#006064', '#7B1FA2', '#EF6C00', '#FFB300'
  ],
  line: [
    '#0D47A1', '#1565C0', '#1E88E5', '#0288D1', '#006064',
    '#00838F', '#4A148C', '#6A1B9A', '#8E24AA', '#AD1457',
    '#B71C1C', '#C62828', '#D32F2F', '#E65100', '#EF6C00',
    '#F57C00', '#FF8F00', '#F9A825', '#9E9D24', '#5D4037',
    '#37474F', '#263238', '#2E7D32', '#004D40', '#1B5E20'
  ],
  polygon: [
    '#1B1F3B', '#2C3E93', '#0D47A1', '#1565C0', '#1E88E5',
    '#4A148C', '#6A1B9A', '#7B1FA2', '#8E24AA', '#AD1457',
    '#880E4F', '#B71C1C', '#C62828', '#D32F2F', '#E53935',
    '#E65100', '#EF6C00', '#F57C00', '#FB8C00', '#FF6F00',
    '#FF8F00', '#F9A825', '#FDD835', '#6D4C41', '#5D4037',
    '#37474F', '#263238', '#455A64', '#283593', '#3F51B5'
  ]
}

// Layer Styles
export const LAYER_STYLES = {
  point: {
    type: 'symbol',
    layout: { 'icon-size': 0.5, 'icon-anchor': 'bottom', 'icon-allow-overlap': true },
    paint: { 'icon-halo-color': '#FFFFFF', 'icon-halo-width': 2 }
  },
  line: {
    type: 'line',
    layout: { 'line-cap': 'round', 'line-join': 'round' },
    paint: { 'line-width': 4, 'line-opacity': 1 }
  },
  polygon: {
    fill: { type: 'fill', paint: { 'fill-opacity': 0.5 } },
    outline: { type: 'line', paint: { 'line-width': 2.5, 'line-opacity': 1 } }
  }
}

export function generateLayerColor(index, geometryType) {
  let palette
  if (geometryType === 'Point' || geometryType === 'MultiPoint') palette = COLOR_PALETTES.point
  else if (geometryType === 'LineString' || geometryType === 'MultiLineString') palette = COLOR_PALETTES.line
  else palette = COLOR_PALETTES.polygon
  return palette[index % palette.length]
}

// Marker SVG
export const PIN_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 90 90"><path d="M 45 0 C 25.463 0 9.625 15.838 9.625 35.375 c 0 8.722 3.171 16.693 8.404 22.861 L 45 90 l 26.97 -31.765 c 5.233 -6.167 8.404 -14.139 8.404 -22.861 C 80.375 15.838 64.537 0 45 0 z M 45 48.705 c -8.035 0 -14.548 -6.513 -14.548 -14.548 c 0 -8.035 6.513 -14.548 14.548 -14.548 s 14.548 6.513 14.548 14.548 C 59.548 42.192 53.035 48.705 45 48.705 z" fill="#FFFFFF"/></svg>`

// Geometry SVG Icons
export const GEOMETRY_ICONS = {
  point: (color) => `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 90 90"><path d="M 45 0 C 25.463 0 9.625 15.838 9.625 35.375 c 0 8.722 3.171 16.693 8.404 22.861 L 45 90 l 26.97 -31.765 c 5.233 -6.167 8.404 -14.139 8.404 -22.861 C 80.375 15.838 64.537 0 45 0 z M 45 48.705 c -8.035 0 -14.548 -6.513 -14.548 -14.548 c 0 -8.035 6.513 -14.548 14.548 -14.548 s 14.548 6.513 14.548 14.548 C 59.548 42.192 53.035 48.705 45 48.705 z" fill="${color}" stroke="#FFF" stroke-width="2"/></svg>`,
  line: (color) => `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16"><path d="M 2 8 Q 8 2, 12 8 T 22 8" fill="none" stroke="${color}" stroke-width="3" stroke-linecap="round"/></svg>`,
  polygon: (color) => `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><rect x="1" y="1" width="16" height="16" fill="${color}" fill-opacity="0.5" stroke="${color}" stroke-width="2.5"/></svg>`
}

// Popup Configuration
export const POPUP_CONFIG = {
  closeButton: true,
  closeOnClick: false,
  maxWidth: '300px',
  className: 'custom-popup'
}
